module.exports = __webpack_public_path__ + "static/media/5_r_palitpa_86.25_78.89.feff5594.png";